import { LobbyEntryService } from './../../shared/services/lobby-entry.service';
import { EditEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { LobbyStaffStatusGridData } from './../shared/models/lobby-staff-status-grid-data.model';
import { getlobbyStaffGridData } from './../state/selectors/lobby-staff-status.selector';
import { StaffStatusGridGroup } from './../../../shared/models/message-hub/staffStatusGridGroupRequest';
import { Subscription, combineLatest, Observable, of } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { State } from 'src/app/state/app.state';
import { Store } from '@ngrx/store';
import { getAvailableActiveBranches, getCurrentTenant, getIsConnectionStarted, getLobbyLocationSelected, getLobbyShowCategory, getLoggedInUserId, getLoggedInUserInfo, getSignedInStatus, getSystemConfigurations, GetUserPermissionList } from 'src/app/state';
import * as LobbystaffStatusActions from './../state/actions/lobby-staff-status.actions'
import { SortDescriptor } from '@progress/kendo-data-query';
import { map, switchMap, take, tap } from 'rxjs/operators';
import moment from 'moment';
import { ForceSignOutData } from '../../shared/models/force-signout-data';
import { ToastService } from 'src/app/shared/services/toast.service';
import { LobbyService } from '../../shared/services/lobby.service';
import { SystemConfigValue } from 'src/app/admin/system-configuration/shared/models/system-config-value';
import { MapSigninStatus } from 'src/app/shared/mappers/signinstatus.mapper';
import * as CoreActions from 'src/app/state/actions/core.actions';
import { LocationRelationship } from 'src/app/admin/location/shared/models/locationRelationship';
import * as LobbyWrapUpPageActions from 'src/app/lobby/lobby-wrap-up/state/actions/wrap-up-page.actions';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
import { ModalpopupComponent } from 'src/app/shared/modalpopup/modalpopup.component';
import { getPreferredLanguageId } from 'src/app/appointment/appointment-status-grid/state';

@Component({
  selector: 'app-staff-grid',
  templateUrl: './staff-grid.component.html',
  styleUrls: ['./staff-grid.component.scss']
})
export class StaffGridComponent implements OnInit, OnDestroy {
  public interactionData: any;
  public lastInteractionData: any;
  public productAndServiceData: any;
  public data: GridDataResult = {} as GridDataResult;
  public assistTypes = [{ id: 3, name: 'All' }, { id: 1, name: 'Standard' }, { id: 2, name: 'Instant' } ];
  public sort: SortDescriptor[] = [];
  public staffColumnText: string = "";

  public pageSize: number = 0;
  public skip: number = 0;
  public loggedInUserId: number = 0;
  public signedInlocationId: number = 0;

  public selectedAssistType: number = 0;
  public searchText: string = "";
  public sortingField: SortDescriptor = {
    field: ""
  };

  public interactionDialogOpened : boolean = false;
  public productServiceDialogOpened: boolean = false;
  public utcOffSetForSignedInLocation: number = 0;
  public forceSignOutMessage: string = '';

  private subs: Subscription = new Subscription();
  private userIdToSignOut: number = 0;
  public userPermissionList: number[] = [];
  public interactionThreshold: any;
  private enabledInteractionThresholdAlert: boolean = false;
  public isTimeExceeded: boolean = false;
  public enableUserImpersonation: boolean = false;
  public enableUserImpersonationForTenant: boolean = false;
  showLobbyCateogory: boolean = false;
  enableAccountNumber: boolean = false;
  enableDateOfBirth: boolean = false;
  enableCustomField: boolean = false;
  
  public signOutTitleText: string = '';
  public impersonateAssistAlertText: string = '';
  public currentlyAssistingSubText: string = '';

  constructor(
    private store: Store<State>,
    private lobbyEntryService: LobbyEntryService,
    private lobbyService : LobbyService,
    private toastService : ToastService, 
    private translationLoaderFacade: TranslationLoaderFacade,
    private translateService: TranslateService) { }

  ngOnInit() {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (allUserPermissions != undefined)
        this.userPermissionList = allUserPermissions;
    });

    this._setDefaultValues();

    this.subs.add(
      this.store.select(getSystemConfigurations).subscribe(
        (configurations) => {
          const lobbyConfigurations = configurations.filter(c => c.configurationGroup === 'LobbySettings');
          if (lobbyConfigurations.length > 0) {
            this.staffColumnText = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'StaffStatusDisplayText'));
            this.enabledInteractionThresholdAlert = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableInteractionThresholdAlert'));
            this.enableUserImpersonationForTenant = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableUserImpersonation'))
            this.enableAccountNumber = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableAccountNumber'));
            this.enableDateOfBirth = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableDateOfBirth'));
            this.enableCustomField = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableCustomField'));
            
            if (this.enabledInteractionThresholdAlert) {
              this.interactionThreshold =  this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'InteractionThreshold'))
            }
          }
        }
      )
    );

    const dataSelectorSubscription = this.store.select(getlobbyStaffGridData).subscribe(gridData => {
      if (gridData != null)
        this._onReceiveData(gridData);
    });

    const signalRConnectionSubscription = this._retrieveDataIfHubIsConnected();

    const getLobbyCategorySub = this.store.select(getLobbyShowCategory).subscribe((lobbyCategory) => { 
      this.showLobbyCateogory=lobbyCategory;    
    });

    this.subs.add(signalRConnectionSubscription);
    this.subs.add(dataSelectorSubscription);
    this.subs.add(getLobbyCategorySub);
    this.store.select(getLoggedInUserId).subscribe(userId => {
      if (userId != undefined)
        this.loggedInUserId = userId
    });

    const userInfoSubscription = this.store.select(getLoggedInUserInfo).subscribe((userInfo) => {
      if (userInfo != null) {
        this.enableUserImpersonation=userInfo.enableUserImpersonation;       
      }
    });

    this.subs.add(userInfoSubscription);
    this.store.select(getLobbyLocationSelected).subscribe((location) =>
    {
      if (this.signedInlocationId != location.locationId) {
        this.signedInlocationId = location.locationId
        this._retrieveData();
      }
      
    } );
    this.translateService.get(['_General_All_Text_','_Lobby_Standard_Ts_Text_','_Lobby_Instant_Ts_Text_', '_Shared_App_SignOut_Title_Text_', '_Lobby_Central_Impersonate_Assit_Alert_Text_', '_General_Currently_Assisting_Sub_Ts_Text_']).subscribe(
      (translations) => {
        this.assistTypes = [{ id: 3, name: translations['_General_All_Text_'] }, { id: 1, name: translations['_Lobby_Standard_Ts_Text_'] }, { id: 2, name: translations['_Lobby_Instant_Ts_Text_'] } ];
        this.signOutTitleText = translations['_Shared_App_SignOut_Title_Text_'];
        this.impersonateAssistAlertText = translations['_Lobby_Central_Impersonate_Assit_Alert_Text_'];
        this.currentlyAssistingSubText = translations['_General_Currently_Assisting_Sub_Ts_Text_'];
      }
    )   
  }
  
  /**
   *
   * Triggers when clicking info icon of row
   */
public infoClickedHandler(event: EditEvent) {
  this._openInfoDialogForLobbyEntry(event.dataItem.currentAssistingLobbyId);  
}

public OpenWrapup(dataItem: any) {  
  this.store.dispatch(LobbyWrapUpPageActions.loadWrapUpPopUp({ lobbyEntryId: dataItem.currentAssistingLobbyId, isImpersonateAssist: true, impersonatedByName: dataItem.staffName, showLobbyCateogory: this.showLobbyCateogory, impersonatedByCode: dataItem.staffCode}));
}

  private _setDefaultValues(){
    this.sort = [{ field: 'staffName', dir: 'asc' }];
    this.sortingField = this.sort[0];
    this.pageSize = 10;
    this.skip = 0;
    this.selectedAssistType = this.assistTypes[0].id;
    this.searchText = '';
  }

  private _onReceiveData(gridData: LobbyStaffStatusGridData){
    if(gridData){
      this.data = {
        data:gridData.data ?? [],
        total: gridData.totalRowCount ?? 0
      };    
      this.pageSize = gridData.pageSize ?? 1;
      this.skip = (gridData.currentPageNumber -1 ) * this.pageSize
    } else {
      this._setDefaultValues();
    }
  }

  private _retrieveDataIfHubIsConnected(): Subscription {
    return this.store.select(getIsConnectionStarted).subscribe(
      isHubConnected => {
        if (isHubConnected) {
        }
      });
  }

  private _retrieveData() {
    this._getParamsFromLatestGridParams().subscribe(gridParams => {     
      this.store.dispatch(
        LobbystaffStatusActions.loadLobbyStaffGridData({ gridParams }));
    });

  }

  public onAssistTypeChange() {
    this._getParamsFromLatestGridParams().subscribe(gridParams => {    
      
      this.store.dispatch(
        LobbystaffStatusActions.loadLobbyStaffGridData({ 
          gridParams:Object.assign({}, gridParams,
            { Page: 1 }
          )
           }));
    });
  }

  private _getParamsFromLatestGridParams(): Observable<StaffStatusGridGroup> {
    return combineLatest([this.store.select(getLobbyLocationSelected), this.store.select(getCurrentTenant), this.store.select(getPreferredLanguageId)]).pipe(
      take(1),
      switchMap(([locationSelected, currentTenant, preferredLanguageId]) => {       
          this.utcOffSetForSignedInLocation = locationSelected.utcOffSet;
          return of<StaffStatusGridGroup>({
            TenantId: currentTenant?.tenantID,
            LocationId: locationSelected?.locationId,
            Page: (this.skip / this.pageSize) + 1,
            PageSize: this.pageSize,
            SortColumn: this._fieldNameCorrection(this.sortingField.field),
            SortDirection: this.sortingField.dir == undefined ? "asc" : this.sortingField.dir, // if sorting field is undefined we set 'asc' by default
            SearchText: this.searchText,
            LanguageKey: "",
            AssistTypeId: this.selectedAssistType === 3 ? -1 : this.selectedAssistType,
            PreferredLanguageId: preferredLanguageId
          });
      }
    ));
  }

  private _openInfoDialogForLobbyEntry(lobbyEntryId: number){
    this.lobbyEntryService.getLobbyEntryDetails(lobbyEntryId).subscribe((lobbyEntryData) => {

      this.interactionData = lobbyEntryData;
      this.lastInteractionData = JSON.parse(JSON.stringify(lobbyEntryData.lobbyInteractions.find((data: any) => data.completedLocalTime == null)));
      let miliseconds = moment(moment.utc()).diff(moment.utc(this.lastInteractionData.assistedTime));
      let duration = moment.duration(miliseconds);
      this.interactionData['assistingLocalTime'] = duration.asSeconds();
      this.interactionData['assistingStartTime'] = this.lastInteractionData.assistedLocalTime;
      this._openInteractionDialog();
    })
  }
  public onTimeExceededHandler(event: boolean): void {
    this.isTimeExceeded=event;   
    
}
  private _openProductServiceDialogForLobbyEntry(lobbyEntryId: number){
    this.lobbyEntryService.getLobbyEntryDetails(lobbyEntryId).subscribe((lobbyEntryData) => {
      this.productAndServiceData = lobbyEntryData;
      this._openProductServiceDialog();
    })
  }

  private _openInteractionDialog(){
    this.interactionDialogOpened = true;
  }

  private _openProductServiceDialog() {
    this.productServiceDialogOpened = true;
  }

  // MessageHub request excepts first name to be capital for the fieldnames hence convert it before sending the request
  private _fieldNameCorrection(fieldName: string): string {
    switch (fieldName) {
      case 'locationName':
        return 'LocationName';
      case 'staffName':
        return 'StaffName';
      case 'staffCode':
        return 'StaffCode';
      case 'status':
        return 'Status';
      case 'currentAssisting':
        return 'CurrentAssisting';
      case 'serviceRequested':
        return 'ServiceRequested';
      case 'currentAssistTime':
        return 'CurrentAssistTime'
      default:
        return 'LocationName';
    }
  }

  private readCastedValue(systemConfigValue?: SystemConfigValue): any {
    if (systemConfigValue) {
      switch (systemConfigValue.dataType) {
          case 'int':
              return parseInt(systemConfigValue.value, undefined);
          case 'bool':
              return (systemConfigValue.value === '1');
          default:
              return systemConfigValue.value;
      }
    }
  }

  // Handlers
  public onPageChange(event: PageChangeEvent) {
    this.skip = event.skip;
    this._retrieveData();
  }

  public onSortChange(event: SortDescriptor[]) {   
    this.sort = event;
    this.sortingField = event[0];
    this._retrieveData();
  }

  public onItemInfoClicked(item: any){
    this._openInfoDialogForLobbyEntry(item.currentAssistingLobbyId);
  }

  public productClickedHandler(item: any){
    this._openProductServiceDialogForLobbyEntry(item.currentAssistingLobbyId);
  }

  public closeInteractionDialog(){
    this.interactionDialogOpened = false;
  }

  public closeProductServiceDialog(){
    this.productServiceDialogOpened = false;
  }
  // Handlers End
  public showForceSignOutIcon(dataItem: any)
  {
    if(dataItem.staffId === this.loggedInUserId || dataItem.statusId === 3)
    {
      return false;
    }
      return true;
  }

  showSignOutTitle(dataItem: any)
  {
    const signOutTitle = `${this.signOutTitleText} ${dataItem.staffName}`;
    return signOutTitle;
  }

  showForceSignOutPopUp(rowData: any, popUp: ModalpopupComponent)
  {
    this._showUnableToSigninPopup().subscribe(branchesAvailable => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe((status: boolean) => {
          if (status) {
            this.userIdToSignOut = rowData.staffId;
            if(rowData.isProvideImpersonateAssist){
              this.forceSignOutMessage=`${rowData.staffName} ${this.impersonateAssistAlertText}`;
              popUp.dialogOpened = true;
            }    
            else if(rowData.currentAssisting)
            {
              this.forceSignOutMessage = `${rowData.staffName} ${this.currentlyAssistingSubText}`;
              popUp.dialogOpened = true;
            }
            else
            {
              this._forceSignOut();
            }
          }
        })
      }
    });
  }

  userForceSignOut(popUp: ForceSignOutData)
  {
    popUp.dialogOpened = false;
    this._forceSignOut();
  }

  private _getForceSignOutData()
  {
    const forceSignOutData: ForceSignOutData = {
      locationId: this.signedInlocationId,
      signedOutByUserId: this.loggedInUserId,
      userIdToSignOut: this.userIdToSignOut,
      signedOutByUserLocationId: this.signedInlocationId,
      signedOutType: "backtolobby"
    };

    return forceSignOutData;
  }

  private _forceSignOut()
  {
    const forceSignOut = this._getForceSignOutData();
    this.lobbyService.userForceSignOut(forceSignOut).subscribe({
      next : () => {this.toastService.showSuccess('_General_User_Force_Sign_Out_Successfully_Ts_Text_')},
      error : () => {this.toastService.showError('_General_User_Force_Sign_Out_Failed_Ts_Text_')} 
    });
  }

  // Utilies
  // TODO: Refactor and move into sign-in-popup service
  private _showSigninPopupIfNotSignedInAlready(): Observable<boolean> {

    return this.store.select(getSignedInStatus).
      pipe(
        map(signInStatus => {
          if (signInStatus != null)
            return MapSigninStatus(signInStatus)
          else return false;
        }),
        take(1), // This would remove the need for the subscriber to unsubscribe
        tap(status => {
          if (!status) {
            this.store.dispatch(CoreActions.promptUserToSignin({payload:{isSelectorChange:false}}));
          }
        })
      );
  }

  // TODO: Refactor and move into sign-in-popup service
  private _showUnableToSigninPopup(): Observable<boolean> {
    return this.store.select(getAvailableActiveBranches)
      .pipe(
        take(1),
        tap((b:LocationRelationship[]) => {
          if (b.length == 0) this.store.dispatch(CoreActions.promptUnableToSignin());
        }),
        switchMap(b => of(b.length > 0))
      );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    const groupNames = [
      'StaffStatusGridGroup'      
    ];
    this.store.dispatch(CoreActions.unsubscribeFromSignalRGroups({ groupNames }));
  }

  public searchKeyWordChange() {
    this._getParamsFromLatestGridParams().subscribe(gridParams => {     
    
      this.store.dispatch(
        LobbystaffStatusActions.loadLobbyStaffGridData({ gridParams }));
    });
  }

  public clearSearchKeyWordChange() {
    this.searchText = "";
    this._getParamsFromLatestGridParams().subscribe(gridParams => {     
    
      this.store.dispatch(
        LobbystaffStatusActions.loadLobbyStaffGridData({ gridParams }));
    });
  }
}
